<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Secciones</li>
      </ol>
    </nav>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <md-card>
                    <md-card-header>
                        <div class="md-title">Filtros</div>
                    </md-card-header>
                    <md-card-content>
                        <div class="row">
                            <div class="col-md-3">
                                <md-field v-if="flows.length > 0">
                                    <label>Flujo</label>
                                    <md-select v-model="selected_flow">
                                        <md-option v-for="flow in flows" :value="flow.id" :key="flow.name">{{flow.name}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="col-md-3" v-if="loadingForms">
                                <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/>
                            </div>
                            <div class="col-md-3" v-else>
                                <md-field v-if="forms.length > 0">
                                    <label>Forma</label>
                                    <md-select v-model="selected_form">
                                        <md-option v-for="form in forms" :value="form.id" :key="form.name">{{form.name}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="col-md-2" v-if="selected_form != null">
                                <md-progress-spinner v-if="loading" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/>
                                <md-button v-else class="md-raised md-primary" @click="getSectionsByFormID()">
                                    Filtrar
                                </md-button>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-12">
                <md-card>
                    <md-card-header>
                        <div class="md-title">Secciones
                            <md-progress-spinner v-if="loading" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/>
                            <md-button v-else class="md-raised md-primary" @click="getSections()">
                                Ver todas
                            </md-button>
                            <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editSection='New'">
                                <md-icon>add</md-icon>
                            </md-button>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table>
                            <md-table-row>
                                <md-table-head>ID</md-table-head>
                                <md-table-head>Nombre</md-table-head>
                                <md-table-head>Nombre Público</md-table-head>
                                <md-table-head>Descripción Pública</md-table-head>
                                <md-table-head style="text-align: center">Editar | Borrar | Ver Campos</md-table-head>
                            </md-table-row>
                            <md-table-row v-if="editSection==='New'">
                                <md-table-cell>{{editSection}}</md-table-cell>
                                <md-table-cell>
                                    <md-field>
                                        <label>Nombre</label>
                                        <md-textarea v-model="name" md-autogrow/>
                                    </md-field>
                                </md-table-cell>
                                <md-table-cell>
                                    <md-field>
                                        <label>Nombre Público</label>
                                        <md-textarea v-model="public_name" md-autogrow/>
                                    </md-field>
                                </md-table-cell>
                                <md-table-cell>
                                    <md-field>
                                        <label>Descripción Pública</label>
                                        <md-textarea v-model="public_description" md-autogrow/>
                                    </md-field>
                                </md-table-cell>
                                <md-table-cell style="width: 16%;text-align: center">
                                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarSection()">
                                        <md-icon>save</md-icon>
                                    </md-button>
                                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                                        <md-icon>clear</md-icon>
                                    </md-button>
                                </md-table-cell>
                            </md-table-row>
                            <md-table-row v-for="section in sections" :key="section.id">
                                <md-table-cell>{{section.id}}</md-table-cell>

                                <md-table-cell v-if="editSection===section.id">
                                    <md-field>
                                        <label>Nombre</label>
                                        <md-textarea v-model="name" md-autogrow/>
                                    </md-field>
                                </md-table-cell>
                                <md-table-cell v-else>{{section.name}}</md-table-cell>

                                <md-table-cell v-if="editSection===section.id">
                                    <md-field>
                                        <label>Nombre Público</label>
                                        <md-textarea v-model="public_name" md-autogrow/>
                                    </md-field>
                                </md-table-cell>
                                <md-table-cell v-else>{{section.public_name}}</md-table-cell>

                                <md-table-cell v-if="editSection===section.id">
                                    <md-field>
                                        <label>Descripción Pública</label>
                                        <md-textarea v-model="public_description" md-autogrow/>
                                    </md-field>
                                </md-table-cell>
                                <md-table-cell v-else>{{section.public_description}}</md-table-cell>

                                <md-table-cell style="width: 20%;text-align: center" v-if="editSection===section.id">
                                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarSection()">
                                        <md-icon>save</md-icon>
                                    </md-button>
                                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                                        <md-icon>clear</md-icon>
                                    </md-button>
                                </md-table-cell>
                                <md-table-cell v-else style="width: 20%;text-align: center">
                                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarSection(section)">
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarSection(section.id)">
                                        <md-icon>delete</md-icon>
                                    </md-button>
                                    <md-button class="md-icon-button md-mini md-raised" v-on:click="verFields(section)">
                                        <md-icon>visibility</md-icon>
                                    </md-button>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Sección: {{selectedSection}} (ID: {{selectedSectionID}})</md-dialog-title>
      <md-card style="overflow-y: auto;">
        <md-card-header>
          <div class="md-title">Campos
            <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editSectionField='New'">
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table>
            <md-table-row>
              <md-table-head>ID</md-table-head>
              <md-table-head>Section</md-table-head>
              <md-table-head>Nombre del Campo</md-table-head>
              <md-table-head>Tooltip</md-table-head>
              <md-table-head>Editar | Borrar</md-table-head>
            </md-table-row>
            <md-table-row v-if="editSectionField==='New'">
              <md-table-cell>{{editSectionField}}</md-table-cell>
              <md-table-cell>{{selectedSectionID}}. {{selectedSection}}</md-table-cell>
              <md-table-cell>
                <md-field>
                  <label>Nombre del Campo</label>
                  <md-textarea v-model="field_name" md-autogrow/>
                </md-field>
              </md-table-cell>
              <md-table-cell>
                <md-field>
                  <label>Tooltip</label>
                  <md-textarea v-model="indication" md-autogrow/>
                </md-field>
              </md-table-cell>
              <md-table-cell style="width: 16%;text-align: center">
                <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarSectionField()">
                  <md-icon>save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiarField()">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-row v-for="section_field in section_fields" :key="section_field.id">
              <md-table-cell>{{section_field.id}}</md-table-cell>
              <md-table-cell>{{section_field.section_id}}. {{selectedSection}}</md-table-cell>

              <md-table-cell v-if="editSectionField===section_field.id">
                <md-field>
                  <label>Nombre del Campo</label>
                  <md-textarea v-model="field_name" md-autogrow/>
                </md-field>
              </md-table-cell>
              <md-table-cell v-else>{{section_field.field_name}}</md-table-cell>

              <md-table-cell v-if="editSectionField===section_field.id">
                <md-field>
                  <label>Tooltip</label>
                  <md-textarea v-model="indication" md-autogrow/>
                </md-field>
              </md-table-cell>
              <md-table-cell v-else>{{section_field.indication}}</md-table-cell>

              <md-table-cell style="width: 20%;text-align: center" v-if="editSectionField===section_field.id">
                <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarSectionField()">
                  <md-icon>save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiarField()">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell v-else style="width: 20%;text-align: center">
                <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarSectionField(section_field)">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarSectionField(section_field.id)">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cerrarDialog()">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'sections',
    props: [],
    mounted() {
      this.getSections();
      this.getFlows();
    },
    data() {
      return {
          flows:[],
        selected_flow: null,
          loadingForms: false,
          forms:[],
        selected_form: null,

          loading: false,
        sections: [],
        editSection: null,
        name: null,
        public_name: null,
        public_description: null,

        showDialog: false,
        selectedSection: '',
        selectedSectionID: null,
        section_fields: [],
        editSectionField: null,
        field_name: '',
        indication: ''
      }
    },
    methods: {
      limpiar(){
        this.editSection = null;
        this.name = null;
        this.public_name = null;
        this.public_description = null;
      },
      getFlows(){
          axios.get( '/api/catalogs/flows').then(response => {
              this.flows = response.data.data;
          });
      },
        getFormsByID(){
            if(this.loadingForms === false) {
                this.loadingForms = true;
                axios.get('/api/catalogs/forms/' + this.selected_flow + '/get').then(response => {
                    this.forms = response.data.data;
                    this.loadingForms = false;
                });
            }
        },
        getSectionsByFormID(){
          if(this.loading === false){
              this.loading = true;
              axios.get( '/api/catalogs/sections/' + this.selected_form + '/get').then(response => {
                  this.sections = response.data.data;
                  this.loading = false;
              });
          }
        },
      getSections(){
          this.selected_flow = null;
          this.selected_form = null;
          if(this.loading === false) {
              this.loading = true;
              axios.get('/api/catalogs/sections').then(response => {
                  this.sections = response.data.data;
                  this.loading = false;
              });
          }
      },
      guardarSection(){
        Vue.toasted.show('Guardando Sección...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/sections/save', {
          'section_id': this.editSection === 'New' ? -1 : this.editSection,
          'name': this.name,
          'public_name': this.public_name,
          'public_description': this.public_description,
        }).then(response => {
          this.limpiar();
          this.getSections();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Sección guardada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarSection(section){
        this.editSection = section.id;
        this.name = section.name;
        this.public_name = section.public_name;
        this.public_description = section.public_description;
      },
      borrarSection(sid){
        Vue.toasted.show('Borrando Sección...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/sections/delete', {
          'section_id': sid,
        }).then(response => {
          this.getSections();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Sección borrada correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      verFields(section){
        axios.get( '/api/catalogs/section_fields/'+section.id+'/get').then(response => {
          this.showDialog = true;
          this.selectedSection = section.name;
          this.selectedSectionID = section.id;
          this.section_fields = response.data.data;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      limpiarField(){
        this.editSectionField = null;
        this.field_name = null;
        this.indication = null;
      },
      guardarSectionField(){
        Vue.toasted.show('Guardando Campo...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/section_fields/save', {
          'section_field_id': this.editSectionField === 'New' ? -1 : this.editSectionField,
          'section_id': this.selectedSectionID,
          'field_name': this.field_name,
          'indication': this.indication
        }).then(response => {
          this.limpiarField();
          axios.get( '/api/catalogs/section_fields/'+this.selectedSectionID+'/get').then(response => {
            this.section_fields = response.data.data;
          }).catch(error => {
            Vue.toasted.clear();
            Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          });
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Campo guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarSectionField(section_field){
        this.editSectionField = section_field.id;
        this.field_name = section_field.field_name;
        this.indication = section_field.indication;
      },
      borrarSectionField(sfid){
        Vue.toasted.show('Borrando Campo...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/section_fields/delete', {
          'section_field_id': sfid,
        }).then(response => {
          axios.get( '/api/catalogs/section_fields/'+this.selectedSectionID+'/get').then(response => {
            this.section_fields = response.data.data;
          }).catch(error => {
            Vue.toasted.clear();
            Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          });
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Campo borrado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      cerrarDialog(){
        this.showDialog = false;
        this.selectedSection = "";
        this.selectedSectionID = null;
        this.section_fields = [];
      }

    },
    watch: {
        selected_flow:function () {
            this.forms = [];
            this.selected_form = null;
            if(this.selected_flow != null){
                this.getFormsByID();
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .src-views-admin-catalogs-sections {

  }
</style>
